module.exports = __webpack_public_path__ + "img/controls.4411ebff.svg";